import { createRouter } from '@tanstack/react-router'
import { Loader2Icon } from 'lucide-react'

import { queryClient } from './lib/query-client'
import { routeTree } from './routeTree.gen'

export { queryClient }

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPendingComponent: RoutePendingSkeleton,
})

function RoutePendingSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 items-center justify-center">
      <Loader2Icon className="text-muted-foreground size-6 animate-spin" />
    </div>
  )
}

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
